import N from 'utils/navigation'
import defaultHandler from 'middlewares/errorHandler/handlers/defaultHandler'

const shopNotFound = (failedRequest: any) => {
  N.push('/settings')
  defaultHandler(failedRequest)
}

export default shopNotFound
